import AppButton from '../../../../commons/buttons/AppButton';
import AppContainer from '../../../../commons/containers/AppContainer';
import AppLinkButton from '../../../../commons/buttons/AppLinkButton';
import AppLoading from '../../../../commons/AppLoading';
import HallAppToast from '../../../../commons/HallAppToast';
import HallPointsAPI from '../../HallPointsAPI';
import { formatInReal } from '../../../../commons/util/HallAppUtil';
import { useState } from 'react';

const hallPointsAPI = new HallPointsAPI();

function HPStepResume5({ closeShow, toBack, data, findAllConfigs, configToEdit }) {

    const [isLoading, setIsLoading] = useState(false);

    const { services, ruleType, pointsConfig, pointsInfo } = data;

    const dayLabels = {
        SUNDAY: 'Domingo',
        MONDAY: 'Segunda-feira',
        TUESDAY: 'Terça-feira',
        WEDNESDAY: 'Quarta-feira',
        THURSDAY: 'Quinta-feira',
        FRIDAY: 'Sexta-feira',
        SATURDAY: 'Sábado',
    };

    const ruleDescriptions = {
        POINTS_FOR_VALUE: 'Pontos a cada valor gasto',
        POINTS_FOR_SERVICE: 'Pontos fixos por serviço',
        POINTS_FOR_PERCENTAGE: 'Pontos por porcentagem do valor gasto',
    };

    const save = async () => {
        try {
            setIsLoading(true)
            if (configToEdit != null && Object.keys(configToEdit).length > 0) {
                await hallPointsAPI.update(configToEdit.id, data);
            } else {
                await hallPointsAPI.create(data);
            }
            HallAppToast.success();
            if (closeShow) {
                findAllConfigs()
                closeShow()
            }
        } catch (_) {
            HallAppToast.genericError();
        } finally {
            setIsLoading(false)
        }
    };


    return (
        <div className="container">
            <div className="my-4">
                <h4 className="mb-4">Resumo da Configuração</h4>

                <div className="card p-3 mb-3">
                    <h5 className="mb-3">Serviços Selecionados</h5>
                    <ul className="mb-0">
                        {services.map((service) => (
                            <li key={service.id}>
                                {service.name}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="card p-3 mb-3">
                    <h5 className="mb-3">Regra de Pontuação</h5>
                    <p><strong>Tipo:</strong> {ruleDescriptions[ruleType] || 'Não especificado'}</p>
                    {ruleType === 'POINTS_FOR_VALUE' && (
                        <p>
                            <strong>Regra:</strong> {pointsConfig.point} ponto(s) a cada {formatInReal(pointsConfig.value)}
                        </p>
                    )}
                    {ruleType === 'POINTS_FOR_SERVICE' && (
                        <p>
                            <strong>Pontos fixos:</strong> {pointsConfig.point} ponto(s) por serviço
                        </p>
                    )}
                    {ruleType === 'PERCENTAGE_FOR_VALUE' && (
                        <p>
                            <strong>Percentual:</strong> {pointsConfig.point}% do valor em pontos
                        </p>
                    )}
                </div>

                <div className="card p-3 mb-3">
                    <h5 className="mb-3">Informações de Validade e Uso</h5>
                    {pointsInfo?.expirationInMonths && (
                        <p><strong>Validade dos pontos:</strong> {pointsInfo.expirationInMonths} mês(es)</p>
                    )}
                    {pointsInfo?.weekDays?.length > 0 && (
                        <>
                            <p><strong>Disponível para uso em:</strong></p>
                            <ul>
                                {pointsInfo.weekDays.map((day) => (
                                    <li key={day}>{dayLabels[day]}</li>
                                ))}
                            </ul>
                        </>
                    )}
                </div>
            </div>
            <div style={{ marginBottom: '220px' }}></div>


            <div
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    padding: '0rem',
                    backgroundColor: '#fff',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.1)',
                    zIndex: 1000,
                }}
            >
                <AppContainer>
                    {
                        isLoading ? <AppLoading /> : <>
                            <AppLinkButton name="salvar" fullWidth={true} onClick={save} />

                            <div style={{ marginTop: '10px' }}>
                                <AppButton name="voltar" width="100%" onClick={toBack} />
                            </div>
                        </>
                    }
                </AppContainer>
            </div>
        </div>
    );
}

export default HPStepResume5;